import { URLS } from "fire-wind-water";
export default {
  initWeChatShare(formInfo) {
    const url = URLS.removeSearchParam(
      window.location.href,
      "token",
      "retCode",
      "puzzleFlag"
    )
      .replace("/success", "/index")
      .replace("/result", "/index");
    const shareInfo = {
      title: formInfo.shareTitle || formInfo.title, // 分享标题,
      desc: formInfo.shareDesc || "", // 分享描述,
      link: URLS.updateSearchParam(
        "return_url",
        encodeURIComponent(url),
        formInfo.shortUrl.wap.longUrl
      ),
      imgUrl: "https:" + formInfo.shareImageRealPath.replace(/^https?:/, ""),
    };
    window.$swxsdk.initWxSdk(
      { tenantId: formInfo.tenantId, weChatId: formInfo.attachWXAccount },
      window.apiUrl
    );
    window.$swxsdk.on("sharer", shareInfo);
    window.$swxsdk.on("sharer_friends", shareInfo);
    if (formInfo.enableShare == 0) {
      window.$swxsdk.on("hideAllNonBaseMenuItem");
    } else {
      window.$swxsdk.on("showAllNonBaseMenuItem");
    }
  },
};
